import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";

import heroImg from '../../../assets/godrejSector12/mainFeed.png'
import logo from '../../../assets/godrejSector12/logo.jpg'

import ph1 from '../../../assets/godrejSector12/ph1.jpg'
import ph2 from '../../../assets/godrejSector12/ph2.jpg'
import ph3 from '../../../assets/godrejSector12/ph3.jpg'
import ph4 from '../../../assets/godrejSector12/ph4.jpg'
import ph5 from '../../../assets/godrejSector12/ph5.jpeg'

import li1 from '../../../assets/godrejSector12/li1.png'
import li2 from '../../../assets/godrejSector12/li2.jpg'
import li3 from '../../../assets/godrejSector12/li3.webp'
import li4 from '../../../assets/godrejSector12/li4.jpg'
import li5 from '../../../assets/godrejSector12/li5.jpg'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const GodrejSector12 = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const ameneties = [
        { id: 0, img: ph1, title: "Minimum dense project" },
        { id: 1, img: ph2, title: "Maximum landscaping" },
        { id: 2, img: ph3, title: "4 sided view" },
        { id: 3, img: ph4, title: "Modern central park" },
        { id: 4, img: ph5, title: "Stand alone towers" },
    ]


    const interiors = [
        { id: 0, img: li1, title: "Musical fountain" },
        { id: 1, img: li2, title: "Ultra luxury club" },
        { id: 2, img: li3, title: "Luxury floating pools" },
        { id: 3, img: li4, title: "Elite floating cabana" },
        { id: 4, img: li5, title: "Elite tower decks" },
    ]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>
            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                The new launch by Godrej Properties in Sector 12, Noida, is an exciting residential project that
                                combines luxury, comfort, and modern living. Here's a detailed description of the project:
                            </p>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Overview:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Godrej Properties has introduced a premium residential project in Sector 12, Noida, offering a range
                                        of 2, 3, and 4 BHK apartments. This project is designed to provide a sophisticated lifestyle with state
                                        of-the-art amenities and excellent connectivity to key areas of Noida and beyond.
                                    </p>
                                </div>
                            </section>



                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Spacious Apartments:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The project offers well-designed apartments with ample natural light
                                        and ventilation, ensuring a comfortable living experience.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Modern Architecture:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The design reflects contemporary aesthetics with a focus on
                                        functionality and elegance.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-4">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Green Spaces:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The project includes beautifully landscaped gardens and open spaces, creating a
                                        serene environment for residents.
                                    </p>
                                </div>
                            </section>


                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold">Amenities</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Residents can enjoy a host of amenities, including:
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                A fully equipped clubhouse
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div> Swimming pool  </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Gymnasium
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Children's play area
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Jogging and cycling tracks
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Sports courts
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Yoga and meditation zones
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                Multipurpose hall for events and gatherings
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>


                            <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Location Advantages :</h2>
                                <p className="text-md text-gray-700 text-justify">
                                    Sector 12 in Noida is a well-connected and vibrant locality with several highlights that make it an
                                    attractive place to live or invest. Here are the main location highlights:
                                </p>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Excellent Connectivity:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Sector 12 is strategically located near the DND Flyway, providing
                                        seamless access to Delhi and other parts of Noida. It is also well-connected via metro stations like
                                        Noida City Centre and Sector 34.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-4">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Proximity to Educational Institutions:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The area is close to reputed schools and colleges,
                                        including Modern School, Nehru International Public School, and Amity Institute of Biotechnology.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Healthcare Facilities:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Residents have access to top-notch healthcare facilities such as Metro
                                        Hospitals, Kailash Hospital, and Apollo Hospitals.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Shopping and Entertainment:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        Sector 12 is near popular shopping hubs like DLF Mall of India,
                                        Wave Mall, and Spice World Shopping Mall, offering a variety of retail and entertainment options.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Employment Hubs:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The locality is close to major commercial and corporate hubs, making it
                                        convenient for working professionals.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto mb-6">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Recreational Spaces:</h3>
                                    <p className="text-md text-gray-700 text-justify">
                                        The area features parks and open spaces, providing a peaceful
                                        environment for residents.
                                    </p>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Sustainability:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Godrej Properties is known for its commitment to sustainability. This project incorporates eco
                                        friendly practices, such as rainwater harvesting, energy-efficient systems, and waste management
                                        solutions.
                                    </p>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <h2 className="text-2xl md:text-3xl font-bold my-2">Investment Potential:</h2>
                                <div className="max-w-4xl mx-auto">
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        With its strategic location, luxurious amenities, and the reputation of Godrej Properties, this project
                                        is an excellent investment opportunity for homebuyers and investors alike.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties.map((item) => item.img)}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                            <div className="relative">
                                <img
                                    src={data.img}
                                    alt={data.title}
                                    className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                                />
                            </div>
                            <div className="px-5 py-3">
                                <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Luxury  Insights
            </h2>
            {openImgModal && activeImageType === "interiors" && (
                <ImageModal
                    images={interiors.map((item) => item.img)}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {interiors.map((data, index) => (
                    <div key={index}
                        onClick={() => handleOpenModal(index, "interiors")}
                        className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                        <div className="relative">
                            <img
                                src={data.img}
                                alt={data.title}
                                className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                        <div className="px-5 py-3">
                            <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default GodrejSector12